<template>
  <div class="cus_select" :tabindex="tabindex" @blur="open = false">
    <!--the case has icon in front of the placeholder-->
    <slot></slot>
    <div
      class="selected jtf_between"
      :class="{ open: open }"
      @click="open = !open"
    >
      <!--isReadonly la true. hoac la placeholder-->
      <div
        v-if="!selected.img_src"
        :class="isPlaceholder ? 'placeholder_select' : 'item_choose'"
      >
        {{ selected }}
      </div>
      <!-- case has img in option -->
      <div v-else-if="selected.img_src">
        <img
          v-bind:src="require('@/assets/images/' + selected.img_src)"
          :alt="selected.img_src"
        />
        {{ selected.value }}
      </div>
      <span>
        <img
          class="select_icon"
          src="@/assets/images/select.svg"
          alt="icon"
        />
      </span>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        class="item"
        :class=" isPlaceholder || isReadonly ? 'highlight' : ''"
        @click="clickOptionBlank()">
        {{ optionNull }}
      </div>
      <div
        class="item"
        v-for="(option, i) of options"
        :key="i"
        :class="option.id === checkValue ? 'highlight' : ''"
        @click="selectOption(option.id, option)"
      >
        <div
          class="mix-option"
          v-if="option.img_src"
          @mouseover="option.isShow = true"
          @mouseout="option.isShow = false"
        >
          <img
            v-if="option.isShow"
            v-bind:src="require('@/assets/images/' + option.img_src_hover)"
            :alt="'hover'"
          />
          <img
            v-if="!option.isShow"
            v-bind:src="require('@/assets/images/' + option.img_src)"
            :alt="'ko hover'"
          />
          {{ option.value }}
        </div>
        <div v-else>
          {{ option.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    defaultValue: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    isReadonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholderValue: {
      type: String,
      required: false,
      default: '選択してください',
    },
    mix_option: {
      type: Array,
    },
    optionNull: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      selected: null,
      checkValue: null,
      open: false,
      isPlaceholder: this.isReadonly || this.default ? null : 'Yes',
      selected_item: null,
    };
  },

  created() {
    if (this.default) {
      this.checkValue = this.default;
    }
    if (this.isReadonly) {
      if (this.options.length > 0) {
        this.selected = this.options ?? this.options[0];
      }

      this.selected = '';
    } else if (this.defaultValue) {
      this.selected = this.defaultValue;
    } else {
      this.selected = this.placeholderValue;
    }
  },
  mounted() {
    this.$emit('input', this.selected);
  },
  methods: {
    selectOption(i, option) {
      this.selected = option.name;
      this.checkValue = i;
      this.open = false;
      this.isPlaceholder = false;
      this.$emit('onSelectItem', option.id);
    },
    clickOptionBlank() {
      this.selected = this.placeholderValue;
      this.checkValue = null;
      this.isPlaceholder = true;
      this.open = false;
      this.$emit('onSelectItem', null);
    },
  },
};
</script>

<style scoped lang="scss">
.cus_select {
  position: relative;
  text-align: left;
  outline: none;
  line-height: 21px;
  font-size: 14px;

  .selected {
    background-color: #ffffff;
    border: 1px solid #9f9f9f66;
    padding: 10px;
    cursor: pointer;
    user-select: none;
    height: 100%;
    .select_icon {
      transition: 0.3;
      transform: rotate(360deg);
    }
  }
  .placeholder_select {
    color: #0c1125;
    opacity: 65%;
  }
  .item_choose {
    color: #222222;
  }

  .selected.open {
    border: 1px solid #04a4de;
    .select_icon {
      transition: 0.3;
      transform: rotate(180deg);
    }
  }

  .items {
    overflow: hidden;
    position: absolute;
    background-color: #fff;
    left: 0;
    right: 0;
    box-shadow: 0px 3px 27px #0000000f;
    border: 1px solid #6262621a;
    border-top: none;
    z-index: 1001;
    max-height: 300px;
    overflow: auto;
    .item {
      padding: 10px 14px;
      cursor: pointer;
      user-select: none;
      min-height: 40px;
      &:focus {
        background-color: #e8f8fe;
        color: #04a4de;
        font-weight: 600;
      }
      &:hover {
        background-color: #f1f2f6;
      }
      .mix-option {
        padding: 12px 10px;
        /* padding-right: 6px; */
        &:hover {
          color: #ffffff;
        }
      }
    }
    .highlight {
      background-color: #e8f8fe;
      color: #04a4de;
      font-weight: bold;
    }
  }
  .selectHide {
    display: none;
  }
}
</style>
